import { createElement } from 'react';
import { ProFormUploadButton as OriginalProFormUploadButton } from '@ant-design/pro-components';
import moment from 'moment';
import axios from 'axios';
const ProFormUploadButton = (props) => {
    const { obs, fieldProps, ...otherProps } = props;
    const { action, method, beforeUpload, customRequest, ...othersFieldProps } = fieldProps ?? {};
    const { open: obsOpen = false, generateUrlFunction, } = obs ?? {};
    const handleGenerateAction = async (file) => {
        if (obsOpen) {
            return file.action;
        }
        if (action) {
            return action;
        }
        return;
    };
    const handleBeforeUpload = async (file, fileList) => {
        let tempFile = file;
        let tempFileList = fileList;
        if (obsOpen) {
            if (!generateUrlFunction) {
                return false;
            }
            const fileName = file.name.substr(0, file.name.lastIndexOf('.')) || file.name;
            const paths = ['upload', `${moment().valueOf()}_${fileName}`].join('/');
            const res = await generateUrlFunction({ ObjectKey: paths, Headers: [{ Key: 'Content-Type', Value: 'text/plain' }] });
            file.url = `https://${res.BucketDomain}/${paths}`;
            file.action = res.SignUrl;
            return file;
        }
        if (beforeUpload) {
            return beforeUpload(file, fileList);
        }
        return file;
    };
    const localCustomRequest = async (options) => {
        const { onProgress, onError, onSuccess, data, filename, file, action, headers = {} } = options;
        try {
            const response = await axios.request({
                method: 'PUT',
                url: file.action,
                withCredentials: false,
                headers: { ...headers, 'Content-Type': 'text/plain' },
                validateStatus: function (status) {
                    return status >= 200;
                },
                onUploadProgress: ({ total, loaded }) => {
                    const percent = +Math.round((loaded / total) * 100).toFixed(2);
                    console.log('percent', percent);
                    onProgress({ percent });
                },
                data: file
            });
            if (response.status < 300) {
                onSuccess({}, file);
            }
        }
        catch (error) {
            onError(error);
        }
        return {
            abort() {
                console.log('upload progress is aborted.');
            },
        };
    };
    return (createElement(OriginalProFormUploadButton, { fieldProps: {
            beforeUpload: handleBeforeUpload,
            customRequest: obsOpen ? localCustomRequest : customRequest,
            ...othersFieldProps,
        }, ...otherProps }));
};
export default ProFormUploadButton;
